/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_Create_KeyInputs */

const en_settings_apikeys_create_key = /** @type {(inputs: Settings_Apikeys_Create_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Key`)
};

const zh_settings_apikeys_create_key = /** @type {(inputs: Settings_Apikeys_Create_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建密钥`)
};

/**
* | output |
* | --- |
* | "Create Key" |
*
* @param {Settings_Apikeys_Create_KeyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_create_key = /** @type {((inputs?: Settings_Apikeys_Create_KeyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_Create_KeyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_apikeys_create_key(inputs)
	return zh_settings_apikeys_create_key(inputs)
});
export { settings_apikeys_create_key as "settings.apikeys.create_key" }